export default "__VITE_ASSET__Cu552kJc__"